// removed by extract-text-webpack-plugin
module.exports = {"button":"_2ngzKAblRYsWnC8WY1tKyM","icon":"_1qP0zhQQQXYlFuslMT6HtS","label":"_3vuuXhCt1mRf2CDj9LzE4N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/iconButton/iconButton.css
// module id = 492
// module chunks = 0